const ajaxList = document.getElementById('js-ajax-list')

if (ajaxList) {
  const categoryElement = document.getElementById('js-category')
  const landingPageElement = document.getElementById('js-landing-page')
  const sort = categoryElement
    ? categoryElement.dataset.sorting
    : landingPageElement.dataset.sorting
  const sortOrder = categoryElement
    ? categoryElement.dataset.order
    : landingPageElement.dataset.order
  const pagesize = 12

  const defaultSorting = categoryElement ? 'weight' : 'created'
  const defaultSortingDirection = categoryElement ? 'asc' : 'desc'

  new Vue({
    el: '#js-ajax-list',
    data: {
      initial: true,
      meta: null,
      products: [],
      pagination: null,
      filters: [],
      brands: [],
      stockFilters: [],
      page: 0,
      hasMoreProducts: false,
      loading: false,
      openDropdown: null,
      filtersOpen: false,
      submenuOpen: false,
      disableRequests: false,
      disabledFilters: [],
      filterTags: [],
      sort: sort || defaultSorting,
      sortOrder: sortOrder || defaultSortingDirection,
      sortLabel: '',
      priceFrom: 0,
      priceTo: 200,
    },
    methods: {
      addToWishList,
      sortedAttributeValues(values) {
        return values.sort((a, b) => a.weight - b.weight)
      },
      filteredAttributes(attributes) {
        const newAttributes = []

        Object.keys(attributes).forEach((key) => {
          const attribute = attributes[key]

          if (
            Object.values(attribute).some((x) =>
              this.filterTags.includes(x.attribute_tag)
            )
          ) {
            const values = Object.values(attribute).filter(
              (x) =>
                !!x.attribute_value_tag &&
                !this.disabledFilters.includes(x.attribute_value)
            )

            if (values.length) {
              newAttributes.push({
                id: key,
                name: values[0].attribute_name,
                values,
              })
            }
          }
        })

        return newAttributes
      },

      getFilterValueLabel(label, tag) {
        const genderValues = [
          'Kids Boys',
          'Kids Girls',
          'Kids Unisex',
          'Baby Unisex',
        ]

        if (tag.includes('-percent')) {
          return tag.replace('-percent', '%')
        } else if (genderValues.includes(label)) {
          return tag
        }

        return label
      },

      toggleFilters() {
        this.filtersOpen = !this.filtersOpen
      },
      toggleSubmenu() {
        this.submenuOpen = !this.submenuOpen
      },
      toggleDropdown(key) {
        if (key == this.openDropdown) {
          this.openDropdown = null
        } else {
          this.openDropdown = key
        }
      },

      toggleFilter($event, tag, label, attribute, name, stock) {
        if ($event.target.checked) {
          if (stock) {
            this.stockFilters.push({ tag, label, attribute })
          } else if (attribute === 'brand') {
            this.brands.push({ tag, label, attribute })
          } else {
            this.filters.push({ tag, label, attribute })
          }
          this.getProducts(true)
        } else {
          this.filters = this.filters.filter((x) => x.tag !== tag)
          this.brands = this.brands.filter((x) => x.tag !== tag)
          this.stockFilters = this.stockFilters.filter((x) => x.tag !== tag)
          this.getProducts(true)

          document.getElementById(`filter-${tag}`).checked = false
        }

        if (!this.initial) {
          if ('ga' in window) {
            tracker = ga.getAll()[0]
            if (tracker) tracker.send('event', 'Filters', name, label)
          }
        }
      },

      applyPricing() {
        this.priceFrom = parseInt(this.$refs.fromInput.value)
        this.priceTo = parseInt(this.$refs.toInput.value)

        this.getProducts(true)
      },

      resetPricing() {
        this.priceFrom = 0
        this.priceTo = 200

        this.getProducts(true)
        
        this.setToggleAccessible(this.$refs.toSlider)
        setTimeout(() => {
          this.fillSlider(this.$refs.toSlider)
        });
      },

      setSorting(sort, sortOrder, sortLabel) {
        this.sort = sort
        this.sortOrder = sortOrder
        this.sortLabel = sortLabel

        this.openDropdown = null

        this.getProducts(true)
      },

      resetFilters() {
        this.disableRequests = true
        document
          .querySelectorAll('#js-ajax-list input[type=checkbox]')
          .forEach((input) => {
            var event = new Event('change')
            input.checked = false
            input.dispatchEvent(event)
          })

        this.resetPricing()

        setTimeout(() => {
          this.disableRequests = false
          this.getProducts(true)
        })
      },

      getProducts(reset, paging, replace) {
        if (this.disableRequests) {
          return false
        }

        this.loading = true

        if (reset) {
          this.products = []
          this.page = 0
        }

        const brands = this.brands.map((x) => x.tag).join('|')
        const attribute_tags_in_stock = this.stockFilters
          .map((x) => x.tag)
          .join('|')

        const atags = Object.keys(this.groupedFilters)
          .map((x) => this.groupedFilters[x].map((x) => x.tag).join('|'))
          .join(',')

        const url = new URL(`${window.location.origin}/ajax`)

        let limit = pagesize + 1
        if (paging) {
          limit = pagesize * (parseInt(paging) + 1) + 1
        }

        let offset = this.page * pagesize
        if (paging) {
          offset = 0
        }

        const params = {
          meta: 'news',
          limit,
          offset,
          brands,
          attribute_tags_in_stock,
          only_in_stock_variants: 1,
          include_meta: 1,
          include_pagination: 1,
          // attribute_tags: this.filters.map((x) => x.tag).join('|'),
          atags,
          sort: this.sort,
          sort_order: this.sortOrder,
          price_range: `${this.priceFrom || 0}|${this.priceTo || 200}`,
        }

        if (!this.initial) {
          // Update URL
          const newUrl = new URL(window.location)
          const search_params = newUrl.searchParams

          if (this.page) {
            search_params.set('page', this.page)
          } else {
            search_params.delete('page')
          }

          if (brands) {
            search_params.set('brands', brands)
          } else {
            search_params.delete('brands')
          }

          if (attribute_tags_in_stock) {
            search_params.set('attr', attribute_tags_in_stock)
          } else {
            search_params.delete('attr')
          }

          if (atags) {
            search_params.set('atags', atags)
          } else {
            search_params.delete('atags')
          }

          if(this.priceFrom != 0 || this.priceTo != 200) {
            search_params.set('price', `${this.priceFrom || 0}|${this.priceTo || 200}`)
          } else {
            search_params.delete('price')
          }

          newUrl.search = search_params.toString()
          const new_url = newUrl.toString()
          window.history.replaceState(null, null, new_url)
        }

        if (categoryElement) {
          params.categories = categoryElement.getAttribute('data-id')
        } else if (landingPageElement) {
          params.landing_pages = landingPageElement.getAttribute('data-id')
        }

        Object.keys(params).forEach((key) => {
          if (params[key]) {
            url.searchParams.append(key, params[key])
          }
        })

        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            if (data.products.length === limit) {
              data.products.pop()
              this.hasMoreProducts = true
            } else {
              this.hasMoreProducts = false
            }

            if (reset || replace) {
              this.products = [...data.products]
            } else {
              this.products = [...this.products, ...data.products]
            }

            this.pagination = data.pagination

            if (this.initial) {
              this.meta = data.meta

              if (window.location.search) {
                setTimeout(() => {
                  this.updateFiltersFromUrl()
                })
              } else {
                this.loading = false
                this.initial = false
              }
            } else {
              this.loading = false
            }
          })
      },
      updateFiltersFromUrl() {
        this.disableRequests = true

        const urlParams = new URLSearchParams(window.location.search)

        let filters = []

        // update paging
        const page = urlParams.get('page')
        if (page) {
          this.page = parseInt(page)
        }

        // update brands
        const brands = urlParams.get('brands')
        if (brands) {
          filters = [...filters, ...brands.split('|')]
        }

        // update attr
        const attrs = urlParams.get('attr')
        if (attrs) {
          filters = [...filters, ...attrs.split('|')]
        }

        // update atags
        const atags = urlParams.get('atags')
        if (atags) {
          filters = [...filters, ...atags.split('|')]
        }

        // update price
        const price = urlParams.get('price')
        if (price) {
          const [from, to] = price.split('|')
          this.priceFrom = parseInt(from)
          this.priceTo = parseInt(to)
        }

        // update filters
        filters.forEach((tag) => {
          const input = document.getElementById(`filter-${tag}`)

          var event = new Event('change')
          input.checked = true
          input.dispatchEvent(event)
        })

        setTimeout(() => {
          this.disableRequests = false
          this.initial = false
          this.getProducts(false, page, true)
        })
      },
      hasCount(variants) {
        return variants.filter((x) => x.name !== 'SAMPL')
      },
      getPrice(price) {
        if (Math.round(price) !== price) {
          return price.toFixed(2)
        } else {
          return price
        }
      },
      getPercentSaved(before, now) {
        return `-${(((before - now) / before) * 100).toFixed(0)}%`
      },
      getThumbnail(thumbnail) {
        return thumbnail.replace('200x200', '320x480')
      },
      nextPage() {
        this.page = this.page + 1

        this.getProducts()
      },

      controlFromInput() {
        const [from, to] = this.getParsed(
          this.$refs.fromInput,
          this.$refs.toInput
        )
        this.fillSlider(this.$refs.toSlider)
        if (from > to) {
          this.$refs.fromSlider.value = to
          this.$refs.fromInput.value = to
        } else {
          this.$refs.fromSlider.value = from
        }
      },

      controlToInput() {
        const [from, to] = this.getParsed(
          this.$refs.fromInput,
          this.$refs.toInput
        )
        this.fillSlider(this.$refs.fromSlider)
        this.setToggleAccessible(this.$refs.toInput)
        if (from <= to) {
          this.$refs.toSlider.value = to
          this.$refs.toInput.value = to
        } else {
          this.$refs.toInput.value = from
        }
      },

      controlFromSlider() {
        const [from, to] = this.getParsed(
          this.$refs.fromSlider,
          this.$refs.toSlider
        )
        this.fillSlider(this.$refs.toSlider)
        if (from > to) {
          this.$refs.fromSlider.value = to
          this.$refs.fromInput.value = to
        } else {
          this.$refs.fromInput.value = from
        }
      },

      controlToSlider() {
        const [from, to] = this.getParsed(
          this.$refs.fromSlider,
          this.$refs.toSlider
        )
        this.fillSlider(this.$refs.toSlider)
        this.setToggleAccessible(this.$refs.toSlider)
        if (from <= to) {
          this.$refs.toSlider.value = to
          this.$refs.toInput.value = to
        } else {
          this.$refs.toInput.value = from
          this.$refs.toSlider.value = from
        }
      },

      getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10)
        const to = parseInt(currentTo.value, 10)
        return [from, to]
      },

      fillSlider(controlSlider) {
        const rangeDistance = this.$refs.toSlider.max - this.$refs.toSlider.min
        const fromPosition =
          this.$refs.fromSlider.value - this.$refs.toSlider.min
        const toPosition = this.$refs.toSlider.value - this.$refs.toSlider.min
        controlSlider.style.background = `linear-gradient(
          to right,
          #C6C6C6 0%,
          #C6C6C6 ${(fromPosition / rangeDistance) * 100}%,
          #2a2d43 ${(fromPosition / rangeDistance) * 100}%,
          #2a2d43 ${(toPosition / rangeDistance) * 100}%, 
          #C6C6C6 ${(toPosition / rangeDistance) * 100}%, 
          #C6C6C6 100%)`
      },

      setToggleAccessible(currentTarget) {
        if (Number(currentTarget.value) <= 0) {
          this.$refs.toSlider.style.zIndex = 2
        } else {
          this.$refs.toSlider.style.zIndex = 0
        }
      },
    },
    computed: {
      allFilters() {
        return [...this.filters, ...this.stockFilters, ...this.brands]
      },
      groupedFilters() {
        return this.filters.reduce((groups, item) => {
          const group = groups[item.attribute] || []
          group.push(item)
          groups[item.attribute] = group
          return groups
        }, {})
      },
    },
    mounted() {
      const disabledValues = document
        .getElementById('js-ajax-filters')
        .getAttribute('data-disabled-values')

      if (disabledValues) {
        this.disabledFilters = disabledValues.split(',')
      }

      this.filterTags = document
        .getElementById('js-ajax-filters')
        .getAttribute('data-filter-tags')
        .split(',')

      this.getProducts()

      setTimeout(() => {
        this.fillSlider(this.$refs.toSlider)
        this.setToggleAccessible(this.$refs.toSlider)
      }, 200)
    },
  })
}
